export const _initialWaveData = [
 { label: 'Wave height', value: '1', unit: 'm',  id: 'wave_height' },
 { label: 'Wave direction', value: '10', unit: '°',  id: 'wave_direction' },
 { label: 'Wave period', value: '10', unit: 's',  id: 'wave_period' },
];

export const _initialWindData = [
 { label: 'Wind speed', value: '10', unit: 'm/s', id: 'wind_speed' },
 { label: 'Wind direction', value: '10', unit: '°',  id: 'wind_direction' },
];

export const _initialSwellData = [
 { label: 'Swell height', value: '10', unit: 'm',  id: 'swell_height' },
 { label: 'Swell direction', value: '10', unit: '°',  id: 'swell_direction' },
 { label: 'Swell period', value: '10', unit: 's', id: 'swell_period' },
];

export const _initialVesselData = [
{ label: 'Vessel Position', value: '53˚23’4N 45˚47’4E', unit: '', id: 'vessel_position' },
{ label: 'Vessel Attainable Top Speed', value: '100', unit: 'Kt', id: 'vessel_max_speed' },
 { label: 'Vessel Speed', value: '10', unit: 'Kt', id: 'vessel_current_speed'}, 
 { label: 'Vessel Heading', value: '10', unit: '°',  id: 'vessel_heading'},
];

export const _initialRollAngleData = [
 { label: 'Predicted Roll Angle', value: '0', unit: '°',  id: 'predicted_roll_angle' },
 { label: 'Roll Angle Zone Limit', value: '13', unit: '°',  id: 'roll_angle_zone_limit' },
];  

export const _initialAccelerationForceData = [
 { label: 'Predicted Acceleration Force Limit', value: '0', unit: 'm/s²', id: 'predicted_acceleration_force_limit' },
 { label: 'Acceleration Force Limit', value: '1.22', unit: 'm/s²', id: 'acceleration_force_limit' },
];  

export const _initialGMData = [
    { label: 'Solid GM', value: '1', unit: 'm', id: 'solid_gm'},
    { label: 'Fluid GM', value: '1', unit: 'm', id: 'fluid_gm'},
]
